import { render } from "./whatWeDo.vue?vue&type=template&id=2922a39e"
import script from "./whatWeDo.vue?vue&type=script&lang=js"
export * from "./whatWeDo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__